import { getQuestionnaireQuestions } from 'modules/questionnaire/helpers';
import { loadOptions } from './loadOptions';

export const getQuestions = async (indication, additionalParams) => {
  if (!indication) {
    return [];
  }

  const _questions = await getQuestionnaireQuestions(indication, additionalParams);
  const questions = JSON.parse(JSON.stringify(_questions));
  for (let i = 0; i < questions.length; i += 1) {
    const q = questions[i];
    // eslint-disable-next-line
    await loadOptions(q, indication, additionalParams);
    if (q.subQuestions) {
      for (let ii = 0; ii < q.subQuestions.length; ii += 1) {
        const sq = q.subQuestions[ii];
        // eslint-disable-next-line
        await loadOptions(sq, indication, additionalParams);
      }
    }
  }
  return questions;
};
